import React, { useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';

function Tab({ id, onClick, selected, text, skipScroll }) {
  const tabRef = useRef(null);

  const handleClick = useCallback(() => {
    onClick(id, tabRef.current);
  }, [onClick, id]);

  useEffect(() => {
    if (selected && tabRef.current && !skipScroll) {
      tabRef.current.scrollIntoView({ inline: 'start' });
    }
  }, [selected, skipScroll]);

  return (
    <SimpleButton
      ref={tabRef}
      label={text}
      onClick={handleClick}
      active={selected}
      color={COLOR.SECONDARY}
      size={SIZE.SMALL}
    />
  );
}

Tab.propTypes = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  skipScroll: PropTypes.bool,
};

Tab.defaultProps = {
  skipScroll: false,
};

export default Tab;
